import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    enablePicker: {
      type: Boolean,
      default: false,
      required: false
    },
    enableMinicartPicker: {
      type: Boolean,
      default: false,
      required: false
    },
    stylingOptions: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    }
  },
  data () {
    return {
      stylingOptionDefaults: {
        group: 'col-12',
        groupRow: 'row',
        groupRowMlr: 'row row-mlr-0',
        items: 'col-12',
        groupBlock: 'col-12',
        groupBlockRow: 'row align-items-center gift-cart-header',
        groupBlockThumbnailBlock: 'col-3 col-sm-1 gift-select-logo',
        groupBlockThumbnailBlockNoImage: 'd-none',
        groupBlockThumbnail: 'img-fluid',
        groupBlockDescription: 'col-9 col-sm-11 gift-select-info-text',
        groupBlockDescriptionNoImage: 'col-12 gift-select-info-text',
        itemsBlock: 'col-12 gift-in-wrapper',
        itemsBlockRow: 'slick-checkout-gifts-slider p-2',
        hint: 'col-12 p-0 text-light px-3',
        hintRow: 'row justify-content-between',
        hintRowMessage: 'col-12 text-center col-sm-auto gift-select-tip',
        hintRowCounter: 'col-12 text-center col-sm-auto ml-auto gift-select-checked-option',
        lniGift: 'lni lni-gift',
        giftBlock: 'mt-2 gift-choice-minicart',
        giftChoiceContent: 'col-12 text-left gift-choice-content',
        giftIconBg: 'col-2 gift-icon-bg',
        giftRuleDescription: 'col-10 gift-rule-description',
        pickYourGift: 'col-12 text-center mb-2 font-weight-bold pick-your-gift-head',
        miniCartGiftSelectionStatus: 'minicart-gift-selection-status'
      }
    }
  },
  computed: {
    ...mapGetters(['shouldGiftRuleHaveSelection']),
    prefilledStylingOptions () {
      return _.defaults(this.stylingOptions, this.stylingOptionDefaults)
    }
  },
  methods: {
    shouldEnablePicker (giftId = null) {
      if (giftId === null) {
        return this.enablePicker
      }
      if (!this.enablePicker) {
        return false
      }
      return this.shouldGiftRuleHaveSelection(giftId)
    },
    shouldEnableMinicartPicker (giftId = null) {
      if (giftId === null) {
        return this.enableMinicartPicker
      }
      if (!this.miniCart) {
        return false
      }
      return this.shouldGiftRuleHaveSelection(giftId)
    }
  }
}
